// Footer.js
import React from 'react';
import './Footer2.css';
import linkedin from './images/linkedin.png'


const Footer = () => {

  const linkedinProfileUrl = 'https://www.linkedin.com/company/credevlapp/about/?viewAsMember=true';

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-social">
        <p>Follow us on LinkedIn:</p>
          <a href={linkedinProfileUrl} target="_blank" rel="noopener noreferrer">
            <img src={linkedin} alt="LinkedIn" />
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 Credvel. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
